import React, { forwardRef } from 'react';
import MaterialTable from 'material-table';
import { CSSProperties } from '@material-ui/core/styles/withStyles';
import AddIcon from '@material-ui/icons/Add';
import { Paper } from '@material-ui/core';
import { useLanguageContext } from '../languages';
import { Offset } from '../../utils/types';
import theme from '../../theme';

const Offsets: React.FC<OffsetProps> = (props) => {
	const { offsets, onRowUpdate, onRowDelete, onRowAdd, sport } = props;

	const { tableLocalization } = useLanguageContext();

	const rowStyle = (rowData: Offset): CSSProperties => {
		if (!rowData.segment || (!rowData.offset && rowData.offset !== 0)) {
			return { color: theme.palette.error.main };
		} else {
			return {};
		}
	};

	if (sport && sport.toLowerCase() === 'football')
		return (
			<MaterialTable
				localization={tableLocalization}
				columns={[
					{
						title: 'Half',
						field: 'segment',
						lookup: {
							1: '1',
							2: '2',
							3: '3',
							4: '4',
							5: '5'
						},
						tooltip: '1: 1st Half, 2: 2nd Half, 3: 1st Half of ET, 4: 2nd Half of ET, 5: Penalty Shootout'
					},
					{
						title: 'Offset (seconds)',
						field: 'offset'
					}
				]}
				editable={{ onRowUpdate, onRowDelete, onRowAdd }}
				data={offsets}
				options={{ pageSize: 2, pageSizeOptions: [2, 5, 10, 20], search: false, sorting: false, emptyRowsWhenPaging: false, rowStyle }}
				title={'Offsets'}
				icons={{
					Add: forwardRef((props, ref) => <AddIcon {...props} ref={ref} data-testid='offsets-actions-new' />)
				}}
				components={{
					Container: (props): JSX.Element => <Paper {...props} data-testid='offsets-table' />
				}}
			/>
		);
	else if (sport && sport.toLowerCase() === 'americanfootball')
		return (
			<MaterialTable
				localization={tableLocalization}
				columns={[
					{
						title: 'Quarter',
						field: 'segment',
						tooltip: '1: 1st Quarter, 2: 2nd Quarter, 3: 3rd Quarter, 4: 4th Quarter, 5: Overtime 1, 6: Overtime 2, 7: Overtime 3, 8: Overtime 4',
						lookup: {
							1: '1',
							2: '2',
							3: '3',
							4: '4',
							5: '5',
							6: '6',
							7: '7',
							8: '8'
						}
					},
					{
						title: 'Offset (seconds)',
						field: 'offset'
					}
				]}
				editable={{ onRowUpdate, onRowDelete, onRowAdd }}
				data={offsets}
				options={{ pageSize: 2, pageSizeOptions: [2, 5, 10, 20], search: false, sorting: false, rowStyle }}
				title={'Offsets'}
				icons={{
					Add: forwardRef((props, ref) => <AddIcon {...props} ref={ref} data-testid='offsets-actions-new' />)
				}}
				components={{
					Container: (props): JSX.Element => <Paper {...props} data-testid='offsets-table' />
				}}
			/>
		);
};

type OffsetProps = {
	offsets: Offset[] | [];
	onRowUpdate?: (newData: Offset, oldData?: Offset) => Promise<unknown>;
	onRowDelete?: (data: Offset) => Promise<unknown>;
	onRowAdd?: (data: Offset) => Promise<unknown>;
	sport?: string;
};

export default Offsets;
